import React from "react";
import "../styles/Policies.css";
import { Link } from "react-router-dom";

function Shipping() {
  return (
    <div className="Conditions-terms">
         <div className="breadcrumb">
          <Link to="/">Home</Link> /{" "}
          <Link to="/Shipping-Policy">Shipping Policy</Link>
        </div> 

      <h1 className="Condition">Shipping Policy</h1>

      <div className="content">
        <p>
          At Sankalp Ayurveda, we strive to make your online shopping experience
          enjoyable, simple, and seamless. To achieve this, we have designed an
          efficient ordering, shipping, and payment process. Below are the
          details of our shipping policy:
        </p>
      </div>

      <h3 className="section-title">1. Shipping Partners</h3>
      <p className="text">
        We use reliable courier partners, including ----, ------, -----,
        --------, and Delhivery, to ensure timely delivery of your products.
      </p>

      <h3 className="section-title">2. Free Shipping</h3>
      <ul className="policy-list">
        <li>
          <strong>Eligibility:</strong>
          <ul>
            <li>Free shipping across India on orders ₹500 or above.</li>
            <li>
              Orders below ₹500 will incur a nominal shipping charge depending
              on rural or urban delivery.
            </li>
          </ul>
        </li>

        <li>
          <strong>Processing Time:</strong>
          <ul>
            <li>Orders dispatched within 1–3 working days.</li>
            <li>Sunday/holiday orders processed next working day.</li>
            <li>Peak periods may cause slight delays.</li>
          </ul>
        </li>
      </ul>

      <h3 className="section-title">3. Delivery Restrictions</h3>
      <ul className="policy-list">
        <li>
          <strong>Delivery Locations:</strong>
          <ul>
            <li>No delivery to P.O. boxes or military addresses.</li>
            <li>Rural deliveries may take extra time.</li>
          </ul>
        </li>
      </ul>

      <h3 className="section-title">4. Order Cancellations</h3>
      <ul className="policy-list">
        <li>
          <strong>By the Customer:</strong>
          <ul>
            <li>Email immediately for cancellation.</li>
            <li>Processed/dispatched orders cannot be cancelled.</li>
            <li>Perishable items: cost borne by customer.</li>
          </ul>
        </li>

        <li>
          <strong>By Sankalp Ayurveda:</strong>
          <ul>
            <li>Sankalp Ayurveda may cancel orders due to unforeseen issues.</li>
            <li>Full refund will be issued.</li>
          </ul>
        </li>

        <li>
          <strong>Non-Delivery or Late Delivery:</strong>
          <ul>
            <li>
              Incorrect address/unavailability may result in re-delivery
              charges.
            </li>
            <li>Customer will be informed accordingly.</li>
          </ul>
        </li>
      </ul>

      <h3 className="section-title">5. Replacement & Refund Policy</h3>
      <p className="text">
        We ensure safe packaging, but rare issues may include:
      </p>
      <ul className="policy-list">
        <li>Damaged during transit</li>
        <li>Manufacturing defects</li>
        <li>Incorrect product delivered</li>
      </ul>

      <h3 className="section-title">6. Conditions for Replacement/Refund</h3>
      <p className="text">Replacement or refund will be processed if:</p>
      <ul className="policy-list">
        <li>Request raised within 5 days of delivery</li>
        <li>Damaged/leaked packages must be refused at delivery</li>
      </ul>
      <p className="text">
        <strong>Note:</strong> Products once accepted cannot be returned unless
        conditions above are met.
      </p>

      <h3 className="section-title">7. Replacement/Refund Process</h3>
      <ul className="policy-list">
        <li>Email us with Order Number and reason for replacement/refund</li>
        <li>Do not return items without prior confirmation</li>
      </ul>

      <p className="text">
        <strong>If replacement is unavailable:</strong>
      </p>
      <ul className="policy-list">
        <li>Best alternative will be offered</li>
        <li>Customer decision will be final</li>
        <li>100% refund if product unavailable</li>
      </ul>

      <h3 className="section-title">8. Delivery Timelines</h3>
      <ul className="policy-list">
        <li>Delivery within 2–7 working days</li>
        <li>If customer unavailable, order may be cancelled</li>
      </ul>

      <h3 className="section-title">9. Contact Information</h3>
      <p className="text">
        For any queries regarding shipping, cancellation, or refunds:
      </p>

      <div className="email">
        <a href="mailto:Sankalphealth10@gmail.com">Email: Sankalphealth10@gmail.com

</a>
      </div>
    </div>
  );
}

export default Shipping;
